var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6720_59832)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6720_59832",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6720_59832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5491 19.1309H17.4571C17.2523 20.6943 15.7123 21.9857 14.0466 22.0001C12.3406 22.0153 10.7856 20.7455 10.5483 19.1309H10.5491Z",
    fill: "#DEA829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3775 17.0275C23.2438 16.6995 22.9701 16.4106 22.7091 16.157C21.3653 14.8536 20.6677 13.2733 20.6566 11.3882C20.6511 10.4809 20.6733 9.57352 20.6511 8.66698C20.5997 6.57705 19.7771 4.85597 18.1858 3.51816C17.2533 2.73484 16.1681 2.28597 14.9588 2.06753L13.0495 2.05713C12.8723 2.09954 12.7212 2.14034 12.5694 2.17235C9.61996 2.79165 7.37055 5.57129 7.35394 8.62457C7.34919 9.57192 7.39902 10.5217 7.33654 11.465C7.28987 12.1739 7.1657 12.8917 6.96559 13.5726C6.63498 14.6991 5.92235 15.5881 5.06735 16.3722C4.51765 16.8755 4.36342 17.5124 4.62205 18.2261C4.85222 18.8614 5.46677 19.2935 6.15251 19.2943C11.3861 19.2975 16.6197 19.2999 21.8533 19.2927C23.0168 19.2911 23.8188 18.1117 23.3767 17.0267L23.3775 17.0275Z",
    fill: "#DEA829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0508 2.05793L14.9601 2.06834C14.2949 1.9209 13.0508 2.05793 13.0508 2.05793Z",
    fill: "#DEA829"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6720_59832",
    x: 0.5,
    y: 2,
    width: 27,
    height: 28.0005,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6720_59832"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6720_59832",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificActive);
export default __webpack_public_path__ + "static/media/notific_active.2c9b3a7cd232df8b4c23924c68bfa67d.svg";
export { ForwardRef as ReactComponent };